function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import { Button, Classes, Spinner } from "@blueprintjs/core";
import classNames from "classnames";
import { onEnterHelper } from "../utils/handlerHelpers";
import { InputField } from "../FormComponents";

var SearchBar = function SearchBar(_ref) {
  var reduxFormSearchInput = _ref.reduxFormSearchInput,
      setSearchTerm = _ref.setSearchTerm,
      loading = _ref.loading,
      searchMenuButton = _ref.searchMenuButton,
      disabled = _ref.disabled,
      autoFocusSearch = _ref.autoFocusSearch;
  var rightElement; // need to always render searchMenuButton so it doesn't close

  if (searchMenuButton) {
    rightElement = /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex"
      }
    }, loading && /*#__PURE__*/React.createElement(Spinner, {
      size: "18"
    }), searchMenuButton);
  } else {
    rightElement = loading ? /*#__PURE__*/React.createElement(Spinner, {
      size: "18"
    }) : /*#__PURE__*/React.createElement(Button, {
      minimal: true,
      icon: "search",
      onClick: function onClick() {
        setSearchTerm(reduxFormSearchInput);
      }
    });
  }

  return /*#__PURE__*/React.createElement(InputField, _extends({
    autoFocus: autoFocusSearch,
    disabled: disabled,
    loading: loading,
    type: "search",
    name: "reduxFormSearchInput",
    className: classNames("datatable-search-input", Classes.ROUND),
    placeholder: "Search..."
  }, onEnterHelper(function (e) {
    e.preventDefault();
    e.stopPropagation();
    setSearchTerm(reduxFormSearchInput);
    e.nativeEvent.stopImmediatePropagation();
  }), {
    rightElement: rightElement
  }));
};

export default SearchBar;